require('./accessibility/menubar-navigation.js');
require('./forms');
require('./main');